import { EntityBase } from './EntityBase';
import { TypeEPISuiteCategory } from './TypeEPISuiteCategory';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class TypeEPISuiteParameter extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   typeColumnLabelId: string;
   typeCategoryId: number;
   ePISuiteParameter: string;
   ePISuiteUnit: string;
   ePISuiteSortOrder: number;
   rowVersion: number;
   typeEpiSuiteCategory: TypeEPISuiteCategory;
}

